import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import ScrollReveal from '../../components/ScrollReveal';

var categories = [
  {
    title: 'Finance & Calculators',
    desc: 'Plan your finances, estimate payments, and calculate returns.',
    tools: [
      { path: '/loan-calculator', title: 'Loan Calculator', desc: 'Calculate monthly payments, total interest, and total cost for any loan or mortgage.' },
      { path: '/salary-calculator', title: 'Salary & Tax Calculator', desc: 'Indian salary calculator with FY 2025-26 tax slabs. Compare old vs new regime.' },
      { path: '/sip-calculator', title: 'SIP Calculator', desc: 'Calculate future value of SIP investments with step-up and lumpsum options.' },
      { path: '/roi-calculator', title: 'ROI Calculator', desc: 'Calculate return on investment for any business decision or campaign.' },
    ],
  },
  {
    title: 'Developer & Data Tools',
    desc: 'Format, encode, convert, and generate data for your projects.',
    tools: [
      { path: '/json-formatter', title: 'JSON Formatter', desc: 'Format, validate, and minify JSON data instantly.' },
      { path: '/base64', title: 'Base64 Encode/Decode', desc: 'Encode text to Base64 or decode Base64 back to text.' },
      { path: '/uuid-generator', title: 'UUID Generator', desc: 'Generate random UUIDs for databases and APIs.' },
      { path: '/timestamp', title: 'Timestamp Converter', desc: 'Convert Unix timestamps to readable dates and back.' },
      { path: '/csv-tools', title: 'CSV Tools', desc: 'Convert CSV to JSON, Excel, XML, YAML, TSV. Upload Excel to CSV.' },
    ],
  },
  {
    title: 'Text Tools',
    desc: 'Write better, format faster, and hit your word count.',
    tools: [
      { path: '/word-counter', title: 'Word Counter', desc: 'Count words, characters, sentences, and estimate reading time.' },
      { path: '/case-converter', title: 'Case Converter', desc: 'Convert text to UPPERCASE, lowercase, Title Case, and more.' },
      { path: '/lorem-generator', title: 'Lorem Ipsum', desc: 'Generate placeholder text for designs and mockups.' },
      { path: '/markdown-preview', title: 'Markdown Preview', desc: 'Type Markdown and see live HTML preview side by side.' },
    ],
  },
  {
    title: 'Security & Passwords',
    desc: 'Stay safe online with strong passwords and secure hashing.',
    tools: [
      { path: '/password-generator', title: 'Password Generator', desc: 'Create strong, random passwords with customizable options.' },
      { path: '/hash-generator', title: 'Hash Generator', desc: 'Generate SHA-1, SHA-256, and SHA-512 hashes from any text.' },
    ],
  },
  {
    title: 'Design & Marketing',
    desc: 'Optimize your content and visuals for maximum impact.',
    tools: [
      { path: '/color-converter', title: 'Color Converter', desc: 'Convert between HEX, RGB, and HSL with live preview.' },
      { path: '/seo-checker', title: 'SEO Checker', desc: 'Analyze page titles, descriptions, and URLs for search optimization.' },
    ],
  },
];

function Tools() {
  return (
    <div className="page-home">
      <SEO title="Free Online Tools — No Sign-Up, 100% Private" description="20+ free online tools for text, data, finance, CSV, security, and design. Everything runs in your browser — your data never leaves your device." path="/tools" />

      <section className="home-hero" style={{ paddingBottom: 'var(--space-6)' }}>
        <div className="container">
          <ScrollReveal>
            <h1 className="home-hero-title">Free Online Tools</h1>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <p className="home-hero-sub">20+ tools for text, data, finance, CSV, security, and design — all in your browser. Your data never leaves your device.</p>
          </ScrollReveal>
        </div>
      </section>

      {categories.map(function (cat, ci) {
        return (
          <section className={ci % 2 === 0 ? 'home-section home-section--tinted' : 'home-section'} key={cat.title}>
            <div className="container">
              <ScrollReveal>
                <h2 className="home-section-title">{cat.title}</h2>
                <p className="home-section-sub">{cat.desc}</p>
              </ScrollReveal>
              <ScrollReveal delay={100}>
                <div className="home-tools-grid">
                  {cat.tools.map(function (t) {
                    return (
                      <Link to={t.path} key={t.path} className="home-tool-card">
                        <h3>{t.title}</h3>
                        <p>{t.desc}</p>
                      </Link>
                    );
                  })}
                </div>
              </ScrollReveal>
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default Tools;
